import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@v2/components/Input';
import { TableFiltersProps } from './types';
import { styles } from './styles';

export function TableFilters({
  search,
  onSearchChange,
  searchPlaceholder = 'Search...',
  className,
}: TableFiltersProps) {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };

  return (
    <div className={clsx(styles.container, className)}>
      <div style={{ maxWidth: 300, flex: 1 }}>
        <Input
          type="text"
          value={search}
          onChange={handleSearchChange}
          placeholder={searchPlaceholder}
          icon={<FontAwesomeIcon icon={faSearch} className="tw-text-neutral-400" />}
        />
      </div>
    </div>
  );
}

export type { TableFiltersProps } from './types';
export default TableFilters;
